import { Controller } from "@hotwired/stimulus";
import { Collapse } from "bootstrap";

// Connects to data-controller="accordion"
export default class extends Controller {
  static targets = ["icon", "collapsable", "hideable"];

  connect() {
    if (this.element.id && window.location.hash === `#${this.element.id}`) {
      this.show();
    }
  }

  disconnect() {
    this.collapser = null;
  }

  toggle() {
    this.collapser ||= new Collapse(this.collapsableTarget);
    this.collapser.toggle();

    this.iconTarget.classList.toggle("fa-chevron-down");
    this.iconTarget.classList.toggle("fa-chevron-up");

    if (this.hasHideableTarget) {
      this.hideableTarget.classList.toggle("d-none");
    }
  }

  show() {
    this.collapser ||= new Collapse(this.collapsableTarget);
    this.collapser.show();

    this.iconTarget.classList.remove("fa-chevron-down");
    this.iconTarget.classList.add("fa-chevron-up");

    if (this.hasHideableTarget) {
      this.hideableTarget.classList.add("d-none");
    }
  }
}
